<template>
    <div :id="id">
        <button class="addPlanoToBasket" @click.prevent.stop="openModalAddPlanoToBasket">
            <span class="icon" :class="status"> <i class="fas fa-shopping-basket fa-1x"></i> </span> {{ $trad.basket.addBasketToPlano }}
        </button>
        <ModalBasket v-if="displayBasket && dataAction.idPlano === item.id" :action="dataAction" @hideBasketModal="close"></ModalBasket>
    </div>
</template>

<script>
import ModalBasket from "@/components/modal/ModalBasket";
export default {
    components: { ModalBasket },
    props: ["item", "id"],
    data: () => ({
        dataAction: {},
        displayBasket: false
    }),
    computed: {
        status() {
            return this.item.status && this.item.status.toLowerCase().replace(" ", "_");
        }
    },
    methods: {
        openModalAddPlanoToBasket(idPlano) {
            this.dataAction = {
                action: "addPlanoToBasket",
                idPlano: this.item.id
            };
            this.displayBasket = true;
        },
        close() {
            this.displayBasket = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.addPlanoToBasket {
    cursor: pointer;
    border: none;
    background-color: black;
    font-size: 12px;
    font-family: "oswald-regular", sans-serif;
    text-transform: none;
    color: white;
    padding: 0;
    padding-right: 4px;

    .icon {
        display: inline-block;
        height: 23.5px;
        line-height: 23.5px;
        width: 23.5px;
        text-align: center;

        &.in_progress {
            background-color: #ff7b15;
        }

        &.approved {
            background-color: #8ab400;
        }

        &.archived {
            background-color: #a3a3a3;
        }

        &.submitted {
            background-color: #41b4e8;
        }
    }
}
</style>



// WEBPACK FOOTER //
// add-to-basket.vue?3bb32482